var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaransaviRightDoubleWinDoor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.2,29.3c-0.2,0-0.4-0.1-0.5-0.3l-0.6-2c-0.1-0.3,0.1-0.5,0.3-0.6c0.3-0.1,0.5,0.1,0.6,0.3l0.6,2 c0.1,0.3-0.1,0.5-0.3,0.6L29.2,29.3z M27.7,24.5c-0.2,0-0.4-0.1-0.5-0.3l-1.2-3.7c-0.1-0.3,0.1-0.5,0.3-0.6 c0.3-0.1,0.5,0.1,0.6,0.3l1.2,3.7c0.1,0.3-0.1,0.5-0.3,0.6L27.7,24.5z M25.7,18c-0.2,0-0.4-0.1-0.5-0.3L24,14 c-0.1-0.3,0.1-0.5,0.3-0.6c0.3-0.1,0.5,0.1,0.6,0.3l1.2,3.7c0.1,0.3-0.1,0.5-0.3,0.6L25.7,18z M23.6,11.6c-0.2,0-0.4-0.1-0.5-0.3 L22,7.5C21.9,7.3,22,7,22.3,6.9c0.3-0.1,0.5,0.1,0.6,0.3l1.2,3.7c0.1,0.3-0.1,0.5-0.3,0.6L23.6,11.6z M21.6,5.1 c-0.2,0-0.4-0.1-0.5-0.3l-1.2-3.7c-0.1-0.3,0.1-0.5,0.3-0.6c0.3-0.1,0.5,0.1,0.6,0.3L22,4.5C22.1,4.7,22,5,21.7,5.1L21.6,5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2,29.3l-0.2,0c-0.3-0.1-0.4-0.4-0.3-0.6L11,25c0.1-0.3,0.4-0.4,0.6-0.3c0.3,0.1,0.4,0.4,0.3,0.6l-1.3,3.7 C10.6,29.1,10.4,29.3,10.2,29.3z M12.4,22.9l-0.2,0c-0.3-0.1-0.4-0.4-0.3-0.6l1.3-3.7c0.1-0.3,0.4-0.4,0.6-0.3 c0.3,0.1,0.4,0.4,0.3,0.6l-1.3,3.7C12.8,22.7,12.6,22.9,12.4,22.9z M14.7,16.5l-0.2,0c-0.3-0.1-0.4-0.4-0.3-0.6l1.3-3.7 c0.1-0.3,0.4-0.4,0.6-0.3c0.3,0.1,0.4,0.4,0.3,0.6l-1.3,3.7C15.1,16.3,14.9,16.5,14.7,16.5z M16.9,10.1l-0.2,0 c-0.3-0.1-0.4-0.4-0.3-0.6l1.3-3.7c0.1-0.3,0.4-0.4,0.6-0.3c0.3,0.1,0.4,0.4,0.3,0.6l-1.3,3.7C17.3,10,17.1,10.1,16.9,10.1z  M19.2,3.7l-0.2,0c-0.3-0.1-0.4-0.4-0.3-0.6l0.8-2.3c0.1-0.3,0.4-0.4,0.6-0.3c0.3,0.1,0.4,0.4,0.3,0.6l-0.8,2.3 C19.5,3.6,19.4,3.7,19.2,3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3,25.9H14.2V5.2h11.1V25.9z M15.1,24.9h9.2V6.1h-9.2V24.9z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 15.1,
    rx: 2.2,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,15.8c-0.1,0-0.3-0.1-0.4-0.2c-0.2-0.2-0.1-0.5,0.1-0.7L28.8,0.6c0.2-0.2,0.5-0.1,0.7,0.1c0.2,0.2,0.1,0.5-0.1,0.7 L12.3,15.7C12.2,15.8,12.1,15.8,12,15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1,29.3c-0.1,0-0.2,0-0.3-0.1L11.7,15.7c-0.2-0.2-0.2-0.5-0.1-0.7c0.2-0.2,0.5-0.2,0.7-0.1l17.1,13.5 c0.2,0.2,0.2,0.5,0.1,0.7C29.4,29.2,29.2,29.3,29.1,29.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,30H0V0h30V30z M1,29H29V1H1V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2,25.7H3.5V4.9h3.6V25.7z M4.5,24.7h1.7V5.9H4.5V24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1,29.7c-0.3,0-0.5-0.2-0.5-0.5V0.9c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v28.3C10.5,29.5,10.3,29.7,10.1,29.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaransaviRightDoubleWinDoor);
export default __webpack_public_path__ + "static/media/faransavi_right_double_win_door.f2bd3257960e9c1ba13df14eb7d84f4a.svg";
export { ForwardRef as ReactComponent };